import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { ImageWithPreview } from '@/components';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledInputLabel = styled.label`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 0 1.5rem 0 0;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
`;

export const StyledListItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledNothingFound = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  color: ${COLORS.IRON_GRAY};
  text-align: center;
  padding-top: 4rem;
`;

export const StyledListItemContentBlock = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
`;

export const StyledListItemRight = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledListItemCover = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7.125rem;
  height: 7.125rem;
  overflow: hidden;
  flex-shrink: 0;
  background: ${COLORS.GRAY_LIGHT};
`;

export const StyledImage = styled(ImageWithPreview)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledListItemSku = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledListItemName = styled.div`
  ${pickThemeFontStyles('18', '20', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledListItemStockQuantity = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledPriceAndQuantity = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledListItemPrice = styled.div`
  ${pickThemeFontStyles('24', '24', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledAmountSelectWrapper = styled.div`
  flex-grow: 0;
  &&& > div:hover {
    background: transparent;
    border: 1px solid ${COLORS.BLACK_PRIMARY};

    .ant-input-number {
      background: transparent;
    }
  }

  &&& .ant-input-number {
    width: 4rem;
  }
`;

export const StyledAddProductsButton = styled(Button)`
  &&& {
    height: 2.5rem;
    padding: 0.75rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledAlreadyAdded = styled.div`
  ${pickThemeFontStyles('18', '28', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
`;
